
// import "../css/style.css";
import icespice from '../css/img/icespice-logo.png'
import check from '../css/img/check.png'
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Link, useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { useEffect,useState } from 'react';
import { BottomSheetCustom } from '@cred/neopop-web/lib/components';
import BottomLogin from './bottomLogin';
import BottomLoginDirect from './bottomLoginDirect';

function LoginPenta() {
    // let {session_token} = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    let session_token = searchParams.get("session_token")
    const [issOpen, setsOpen] = useState();
    const location = useLocation();
    const nav = useNavigate();
    // console.log(session_token)
    // console.log(window)
// if (window.location.host ==="localhost:3000") {
//   console.log("enter")
//   window._env_ = {
//     REACT_APP_LIVE_API_URL: "https://staging.icespice.com",
//   }
// } else {
//   window._env_ = {
//     REACT_APP_LIVE_API_URL: "https://icespiceapi.betheforce.in",
//   }
// }
    if(!session_token || session_token === localStorage.getItem('sessionId')){
      // console.log("restored")
      session_token = localStorage.getItem('sessionId')
    }else{
      // console.log(session_token)
      localStorage.clear()
      localStorage.setItem("sessionId",session_token)
    }
    useEffect(()=>{
      // localStorage.setItem("token","")
    //   setTimeout(() => {
    //     // alert("flsk")
    //       return nav(`/s/${session_token}`,{ replace: true });
    //   }, 3000);
    },[])
  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Congratulations</title>
        </Helmet>
      </HelmetProvider>
      
    <div className='container'>
    <main className="popup-main">
    <div className="circleblurbg"></div>

    <img src="/assets/images/Penta-Vertical-Logo.png" style={{width:"80px"}}alt="Penta Logo" />
<div className='rowGap10'/>
    <img src="/assets/images/icespice-logo.png" alt="IceSpice Logo" />
    <h4 className='mt-4'>
      <div className="line">Hey!!! Welcome to IceSpice.</div> <br />
      <div className="line">
        Play the game, earn SpiceGold and use SpiceGold to get discounts on some
        cool stuff!{" "}
      </div>
      <div className="line">Sign Up and Get Discounted Goodies</div>
    </h4>
    <button className="btn btnPrimary" onClick={()=>{setsOpen(true)}}>Login</button>
  </main>
    </div>
    <BottomSheetCustom open={issOpen} handleClose={location.pathname==="/penta"?()=>{setsOpen(!issOpen)}:() => {setsOpen(!issOpen);return nav(-1)} } maxHeight='700px'>
                      <BottomLoginDirect reredirect={location.pathname}/>
  </BottomSheetCustom>
</>
  );
}

export default LoginPenta;
